import _ from 'underscore'

export function prepareSerialTicketsForBooking(tickets, previousTickets) {
  return tickets.map(ticket => ({
    ...ticket,
    count: previousTickets?.find(({ code }) => code === ticket.code)?.count || 0,
    maxCount: 99
  }))
}

export function groupByRoute(tickets) {
  const ticketsGroupedByRoute = _.groupBy(tickets, ticket => `${ticket.from}-${ticket.to}`)
  return Object.values(ticketsGroupedByRoute).map(tickets => ({
    from: tickets[0].from,
    to: tickets[0].to,
    tickets
  }))
}

export function groupByType(tickets) {
  const ticketsGroupedByType = _.groupBy(tickets, ticket => ticket.type)
  return Object.values(ticketsGroupedByType).map(tickets => ({
    type: tickets[0].type,
    serialTickets: tickets
  }))
}

export function getRoutePriority(ticket) {
  const routePriorities = ['TAL-HEL', 'MUG-VSS']
  const routePriority = routePriorities.indexOf(`${ticket.from}-${ticket.to}`)

  return routePriority === -1 ? 1000 : routePriority
}

export function getTypePriority(ticket) {
  const typePriorities = ['PASSENGER', 'VEHICLE']
  const typePriority = typePriorities.indexOf(ticket.type?.toUpperCase())

  return typePriority === -1 ? 1000 : typePriority
}

export function getPackageSize({ name }) {
  return name?.match(/^\d+/g)?.map(Number)[0] || null
}
